import { isWeb } from '@gluestack-ui/nativewind-utils/IsWeb';
import { tva } from '@gluestack-ui/nativewind-utils/tva';

const baseStyle = isWeb
  ? 'font-sans tracking-sm bg-transparent border-0 box-border display-inline list-none margin-0 padding-0 position-relative text-start no-underline whitespace-pre-wrap word-wrap-break-word'
  : '';

const baseHeadingSizes = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] as const;

const baseTextSizes = [
  '2xs',
  'xs',
  'sm',
  'md',
  'lg',
  'xl',
  '2xl',
  '3xl',
  '4xl',
  '5xl',
  '6xl',
] as const;

const baseHeadingTextSizes = [
  ...baseTextSizes,
  ...baseHeadingSizes.flatMap((heading) => baseTextSizes.map((size) => `${heading}-${size}`)),
] as const;

type BaseHeadingTextSizes = (typeof baseHeadingTextSizes)[number];

export type Size = { size?: BaseHeadingTextSizes };

const headingTextSizesLookup: Record<BaseHeadingTextSizes, string> = baseHeadingTextSizes.reduce(
  (lookup, key) => {
    return {
      ...lookup, // convert h1-xs → text-xs AND h1-md → text-base
      [key]: key.replace(/^h\d/, 'text').replace('md', 'base'),
    };
  },
  {} as Record<BaseHeadingTextSizes, string>
);

export const headingStyle = tva({
  base: `${baseStyle} tracking-sm my-0 font-bold font-heading text-typography-900`,
  variants: {
    isTruncated: {
      true: 'overflow-hidden text-ellipsis whitespace-nowrap',
    },
    bold: {
      true: 'font-bold',
    },
    underline: {
      true: 'underline',
    },
    strikeThrough: {
      true: 'line-through',
    },
    sub: {
      true: 'text-xs',
    },
    italic: {
      true: 'italic',
    },
    highlight: {
      true: 'bg-yellow-500',
    },
    size: headingTextSizesLookup,
  },
});
